/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

defaultCardStyles.titleText = {
    variant: "h5",
    css: css`
        margin-bottom: 20px;
    `,
};

defaultCardStyles.mainWrapper = {
    css: css`
        background-color: ${getColor("common.background")};
        border: 1px solid ${getColor("common.ui12")};
        border-radius: 4px;
        padding: 20px;
    `,
};

defaultCardStyles.headerWrapper = {
    css: css`
        margin-bottom: 15px;
        ${cardListStyles.cardHeaderWrapper?.css}
    `,
};

defaultCardStyles.descriptionText = cardListStyles.descriptionText;

defaultCardStyles.container = cardListStyles.cardInfoContainer;

defaultCardStyles.leftColumnGridItem = cardListStyles.leftColumnGridItem;

defaultCardStyles.nameOnCardLabelText = cardListStyles.nameOnCardLabelText;

defaultCardStyles.nameOnCardText = cardListStyles.nameOnCardText;

defaultCardStyles.expirationLabelText = cardListStyles.nameOnCardLabelText;

defaultCardStyles.expirationText = cardListStyles.expirationText;

defaultCardStyles.centerColumnGridItem = cardListStyles.centerColumnGridItem;

defaultCardStyles.billingAddressLabelText = cardListStyles.nameOnCardLabelText;

defaultCardStyles.billingAddressText = cardListStyles.billingAddressText;

defaultCardStyles.linksContainer = cardListStyles.linksContainer;

defaultCardStyles.rightColumnGridItem = cardListStyles.rightColumnGridItem;

defaultCardStyles.editLink = cardListStyles.editLink;

defaultCardStyles.deleteLink = cardListStyles.deleteLink;
